<template>
  <div></div>
</template>
<script>
import RequesterAuthentication from "./requesters/authentication.js";

export default {
  name: "AuthenticationLogout",
  data: function () {
    return {};
  },

  methods: {
    logout: async function () {
      this.$store.commit("authentication/logout");
      this.$store.commit("user/set_full_name", null);
      this.$store.commit("user/set_entity_types", null);
      await RequesterAuthentication.logout();
      this.$router.push({ name: "login_path" });
    },
  },
  created() {
    this.logout();
  },
};
</script>
